import { useState } from "react";

const useModal = (initialProps = {}) => {
  const [stateModal, setState] = useState({
    isOpen: initialProps.isOpen || false,
  });

  const setModal = (field, value) => {
    if (typeof field === "object") {
      setState((prevState) => ({ ...prevState, ...field }));
    } else {
      setState((prevState) => ({ ...prevState, [field]: value }));
    }
  };

  const toggleModal = () => {
    setState((prevState) => ({
      ...prevState,
      isOpen: !prevState.isOpen,
    }));
  };

  return {
    stateModal,
    setModal,
    toggleModal,
  };
};

export default useModal;
